import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from '../assets/images/logo512.png';
import { FaBars, FaTimes } from 'react-icons/fa';

const Header = () => {
  const [showWorkDropdown, setShowWorkDropdown] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    setShowWorkDropdown(false);
  };

  return (
    <nav className="casc-header">
      <Link to="/" className="casc-logo-link">
        <img src={logo} alt="CASC Logo" className="casc-logo" />
      </Link>
      
      {/* Mobile menu button */}
      <button className="mobile-menu-button" onClick={toggleMobileMenu}>
        {mobileMenuOpen ? <FaTimes /> : <FaBars />}
      </button>

      <div className={`casc-nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
        <Link to="/" className="casc-nav-link" onClick={() => setMobileMenuOpen(false)}>HOME</Link>
        
        <div 
          className="casc-nav-link casc-dropdown-trigger"
          onMouseEnter={() => setShowWorkDropdown(true)}
          onMouseLeave={() => setShowWorkDropdown(false)}
          onClick={() => setShowWorkDropdown(!showWorkDropdown)}
        >
          OUR WORK
          {showWorkDropdown && (
            <div className="casc-dropdown">
              <Link to="/conference" className="casc-dropdown-link" onClick={() => setMobileMenuOpen(false)}>CONFERENCE</Link>
              <Link to="/publicspeakingcontest" className="casc-dropdown-link" onClick={() => setMobileMenuOpen(false)}>PUBLIC SPEAKING</Link>
              <Link to="/others" className="casc-dropdown-link" onClick={() => setMobileMenuOpen(false)}>ARCHIVE</Link>
            </div>
          )}
        </div>
        
        <Link to="/team" className="casc-nav-link" onClick={() => setMobileMenuOpen(false)}>OUR TEAM</Link>
        <Link to="/contact" className="casc-nav-link" onClick={() => setMobileMenuOpen(false)}>CONTACT</Link>
      </div>
    </nav>
  );
};

export default Header;